import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, brandPrimaryActive, brandPrimaryHover, header, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const {
	colors,
	common: { border, borderRadius },
	spacing,
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	cell: {
		padding: spacing.sm,
	},
	addTagButton: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	actionButtons: {
		alignItems: 'center',
		display: 'flex',
		flexDiretion: 'row',
		margin: 0,
		padding: 0,
		gap: spacing.sm,
	},
	link: {
		color: colors.primary.main,
		textDecoration: 'none',
		fontWeight: 600,
		cursor: 'pointer',
	},
	actionsBar: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '16px 24px',
		borderBottom: border,
	},
	leftActions: {
		display: 'flex',
		gap: spacing.md,
		flex: 1,
	},
	rightActions: {
		display: 'flex',
		gap: spacing.md,
		justifyContent: 'flex-end',
	},
	deleteConfirmationTag: {
		marginLeft: spacing.sm,
		marginTop: spacing.sm,
		maxWidth: 150,
	},
	deleteConfirmationTags: {
		marginBottom: spacing.md,
		overflow: 'hidden',
	},
	deleteConfirmationTagsContent: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		margin: '-10px 0 0 -10px',
	},
	loader: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: spacing.lg,
	},
	searchControls: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing.md,
		width: '100%',
	},
	searchDescription: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: `0 ${spacing.md}px`,
		background: white,
		border,
		borderRadius,
		fontSize: 14,
		boxSizing: 'content-box',
		width: '100%',
	},
	databoard: {
		height: 'calc(100vh - 326px)', // This is very finicky, but it works
		background: 'transparent',
		gap: spacing.md,
	},
	databoardBody: {
		background: white,
	},
	sortIcon: {
		marginLeft: spacing.sm,
	},
	sortIconFlipped: {
		transform: 'rotate3d(0,0,1, 180deg)',
	},
	sortMenu: {
		gap: spacing.sm,
	},
	sortMenuItem: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		width: '100%',
		display: 'flex',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	sortTrigger: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 12,
		gap: spacing.sm,
		textTransform: 'uppercase',
		fontWeight: 600,
	},
	placeholder: {
		marginTop: 60,
	},
	alert: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.md,
	},
	searchButton: {
		':active': {
			background: brandPrimaryActive,
		},
		':hover': {
			background: brandPrimaryHover,
		},
		alignItems: 'center',
		background: brandPrimary,
		borderBottomRightRadius: borderRadius,
		borderTopRightRadius: borderRadius,
		cursor: 'pointer',
		display: 'flex',
		height: 40,
		justifyContent: 'center',
		width: 40,
		marginLeft: -40,
		zIndex: 2,
	},
	searchContainer: {
		display: 'flex',
	},
	inputContainer: {
		background: white,
		border,
		borderRadius,
		display: 'flex',
		height: 40,
		minWidth: 400,
		maxWidth: 640,
		padding: 0,
		paddingLeft: spacing.md,
		position: 'relative',

		...CssSelectors.allChildren(
			{
				'::placeholder': {
					color: header,
					fontSize: 16,
				},
			},
			'input'
		),
	},
	searchIcon: {
		fill: colors.primary.contrastText,
		height: 20,
		width: 20,
	},
	nameColumn: {
		width: '35%',
	},
	contactsColumn: {
		width: '15%',
	},
	companiesColumn: {
		width: '15%',
	},
	tagAlertColumn: {
		width: '35%',
	},
	// Favorite styles
	clickable: {
		cursor: 'pointer',
	},
	favoriteCol: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	favorite: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'default',
		position: 'relative',
	},
	favoriteOption: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.md,
		width: '100%',
		fontSize: 14,
	},
	favoriteDropdown: {
		width: 200,
		padding: '5px 0',
	},
	disclosureIconDesc: {
		transform: 'rotate(90deg)',
		marginLeft: 4,
	},
	disclosureIconAsc: {
		transform: 'rotate(270deg)',
		marginLeft: 4,
	},
	noWrap: {
		whiteSpace: 'nowrap',
	},
	cursorNotAllowed: {
		cursor: 'not-allowed',
	},
	mergeTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(242, 182, 57, 0.4)`,
		},
	},
	deleteTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(133, 133, 133, 0.4)`,
		},
	},
	exportTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(137, 201, 71, 0.4)`,
		},
	},
	removeUnusedTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(167, 171, 173, 0.4)`,
		},
	},
	reevaluateTaggingGame: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(4, 102, 255, 0.4)`,
		},
	},
});
